export default "__VITE_PUBLIC_ASSET__4f515c7f__"